export const LOAD_OFFERS = 'mp/show-offers-filter/LOAD_OFFERS';
export const DL_PAGE_LOADED = 'hg/show-offers-filter/DL_PAGE_LOADED';

export const loadOffers = () => {
  return {
    type: LOAD_OFFERS
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/showOffers/showOffersFilter.js
 **/